export default __webpack_public_path__ + "static/media/habilitar-permiso-camara-safari-3.1a9010d3.svg";